import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import * as Yup from 'yup';
import shelfCss from '../PartnerConfigurationShelf.css';
import { partnerShape } from '../../types';
import ParametersFactory from './ParametersFactory';

export const getParametersValidationSchema = parameters =>
    parameters.reduce(
        (total, { name }) => ({
            ...total,
            [name]: Yup.string()
                .nullable()
                .required('STATIC.REQUIRED_FIELD'),
        }),
        {}
    );

function PartnerParameters({ parameters, partner, isReadonly = false }) {
    // Sort parameters by their display index
    const sortedParameters = parameters.sort((a, b) => {
        return (a.displayIndex ?? Infinity) - (b.displayIndex ?? Infinity);
    });

    if (!sortedParameters.length) {
        return null;
    }

    return (
        <>
            <div className={shelfCss.title}>
                <Translate
                    id="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.PARTNER_PARAMETERS"
                    data={{ partnerName: partner.displayName }}
                />
            </div>
            <ParametersFactory parameters={sortedParameters} isReadonly={isReadonly} />
        </>
    );
}

PartnerParameters.propTypes = {
    parameters: PropTypes.array.isRequired,
    partner: partnerShape.isRequired,
    isReadonly: PropTypes.bool,
};

export default PartnerParameters;
